module.exports = __webpack_public_path__ + "img/icon-check-white.37893663.svg";